
import { reviewStarOption, reviewStatusOption, reviewTypeOption, timeRangeOptions } from "@/utils/options";

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue',
        propsData:{
            showMarket:false,
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '星级',
    prop: 'star',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'star',
        propsData: {
            options: reviewStarOption,
            placeholder: '全部星级',
            type: 'multi-check',
            style: {
                width: '140px'
            }
        }
    }],
    defaultValue: []
}, {
    label: '状态',
    prop: 'statusList',
    isFormItem: true,
    labelWidth: '120px',
    width:'135px',
    components: [{
        name: 'gj-select',
        prop: 'statusList',
        propsData: {
            options: [
                {id: 'Nothing', text: '无状态'},
                {id: 'Pending', text: '待处理'},
                {id: 'Processing', text: '处理中'},
                {id: 'Done', text: '已完成'},
            ],
            placeholder: '全部状态',
            type: 'multi-check',
            style: {
                width: '140px'
            }
        }
    }],
    defaultValue: []
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: reviewTypeOption
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'reviewDate'
}]
